/** Each tab is its own route, `/reference-data/<tab>`, so a breadcrumb or a reload lands on it. The first is where `/reference-data` redirects. */
export const REFERENCE_DATA_TABS = [
  'truck-classes',
  'trailer-types',
  'document-types',
  'job-types',
  'reason-codes',
  'zone-kinds',
  'escalation-levels',
] as const;
export type ReferenceDataTab = (typeof REFERENCE_DATA_TABS)[number];

export const REFERENCE_DATA_TAB_LABELS: Record<ReferenceDataTab, string> = {
  'truck-classes': 'Truck classes',
  'trailer-types': 'Trailer types',
  'document-types': 'Document types',
  'job-types': 'Job types',
  'reason-codes': 'Reason codes',
  'zone-kinds': 'Zone kinds',
  'escalation-levels': 'Escalation levels',
};

export function referenceDataTabPath(tab: ReferenceDataTab): string {
  return `/reference-data/${tab}`;
}
